(function () {
    'use strict';

    // @ngInject
    Services.stripe = function stripe($window, ThirdPartyLoaderService) {
        return ThirdPartyLoaderService.loadUrlPromise('https://js.stripe.com/v3/', function() {return $window.Stripe;});
    };


}());